import { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import '../styles/userPoints.css';

const UserListens = forwardRef(({ accessToken, onListenChange }, ref) => {
    const [listens, setListens] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [listensChange, setListensChange] = useState(0);

    const fetchListens = async () => {
        try {
            setLoading(true);
            setError(null);

            const response = await fetch(`${process.env.REACT_APP_BACK4APP_SERVER_PATH}/get-listens?accessToken=${accessToken}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) throw new Error("Failed to fetch listens");

            const data = await response.json();
            setListens(prevListens => {
                const difference = data.listens - prevListens;
                setListensChange(difference);
                return data.listens;
            });

            if (onListenChange) onListenChange(data.listens);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useImperativeHandle(ref, () => ({
        refreshListens: fetchListens,
    }));

    useEffect(() => {
        if (!accessToken) return;
        fetchListens();
    }, [accessToken]);

    if (loading) return (
        <div className="balance-container listens">
            <span className="balance-title">Total Plays Received</span>
            <div className="points-container">
                <div className="points-content loading">
                    <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.9941 19.5754L1.98299 19.583L1.97231 19.5912C1.71415 19.7898 1.29175 19.6187 1.29175 19.2209V1.7792C1.29175 1.38133 1.71415 1.21026 1.97231 1.40884L1.9835 1.41745L1.99516 1.42541L14.6931 10.0983L14.6931 10.0984L14.6977 10.1015C14.9759 10.2869 14.9759 10.6652 14.6977 10.8507L14.6977 10.8506L14.692 10.8545L1.9941 19.5754Z" fill="#9FFF9A" stroke="#9FFF9A" />
                    </svg>
                    <p className="loading-points"><span>###</span></p>
                </div>
            </div>
        </div>
    );

    return (
        <div className="balance-container listens">
            <span className="balance-title">Total Plays Received</span>
            <div className="points-container">
                <div className="points-content">
                    <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.9941 19.5754L1.98299 19.583L1.97231 19.5912C1.71415 19.7898 1.29175 19.6187 1.29175 19.2209V1.7792C1.29175 1.38133 1.71415 1.21026 1.97231 1.40884L1.9835 1.41745L1.99516 1.42541L14.6931 10.0983L14.6931 10.0984L14.6977 10.1015C14.9759 10.2869 14.9759 10.6652 14.6977 10.8507L14.6977 10.8506L14.692 10.8545L1.9941 19.5754Z" fill="#9FFF9A" stroke="#9FFF9A" />
                    </svg>

                    <p className={listensChange !== 0 ? 'points-animate' : ''}>
                        {listens}
                        {listensChange !== 0 && (
                            <span className={`points-difference ${listensChange > 0 ? 'positive' : 'negative'}`}>
                                {listensChange > 0 ? `+${listensChange}` : listensChange}
                            </span>
                        )}
                    </p>
                </div>
            </div>

            {error && <p className="error-message">{error}</p>}
        </div>
    );
});

export default UserListens;